<rt-message variant="context-information">
  <div class="info-field" layout layout-align-items-start>
    <rt-icon name="info-outline" colorToken="colorIconInfoDefault" class="info-field__icon" />

    <div class="info-field__content" layout-flex-1>
      @if (title()) {
        <div class="info-field__title">{{ title() }}</div>
      }
      @if (description()) {
        <!-- Security: This value is briefly sanitized by Recruitee/api -->
        <div class="info-field__description" [innerHTML]="safeDescription()"></div>
      }
    </div>
  </div>
</rt-message>
